import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const MuscleIcon = memo(({ fontSize }: SvgIconProps) => {
  return (
    <SvgIcon width="40" height="40" viewBox="0 0 40 40" style={{ fill: 'none', fontSize }} fill="currentColor">
      <g clipPath="url(#clip0_248_5067)">
        <path
          d="M17.05 8.48C17.49 7.9 17.8 7.02 17.06 5.78C16.29 4.5 10.73 3.08 10.17 3.08C8.83999 3.08 6.09999 7.32 5.88999 8.92C4.69999 17.83 2.13999 24.46 2.69999 28.57C2.98999 30.68 3.01999 32.24 4.15999 34.92C5.10999 37.15 10.67 37.27 14.09 37.53C18.46 37.87 23.56 41.07 31.37 38.63C41.2 35.56 39.68 31.33 38.81 28.96C34.65 17.72 21.61 14.36 16.4 24.87C15.11 27.46 14.65 27.55 14.65 27.55C13.01 19.59 10.76 20.06 11.97 14.81C11.97 14.81 15.3 14.11 16.65 12.63C17.44 11.77 19.68 9.6 18.23 8.65C17.02 7.86 16.22 9.18 14.88 9.53"
          fill="#F1CCA5"
        />
        <g clipPath="url(#clip1_248_5067)">
          <path
            d="M23.36 6.22999C23.16 4.84999 22.43 4.11999 21.05 3.91999C20.98 3.90999 20.98 3.81999 21.05 3.80999C22.42 3.60999 23.16 2.87999 23.36 1.49999C23.37 1.42999 23.46 1.42999 23.47 1.49999C23.67 2.86999 24.4 3.60999 25.78 3.80999C25.85 3.81999 25.85 3.90999 25.78 3.91999C24.4 4.11999 23.67 4.84999 23.47 6.22999C23.46 6.29999 23.37 6.29999 23.36 6.22999Z"
            fill="#226937"
          />
          <path
            d="M32.34 18.32C32.15 15.78 30.91 14.53 28.37 14.35C28.34 14.35 28.34 14.3 28.37 14.3C30.91 14.11 32.16 12.87 32.34 10.33C32.34 10.3 32.39 10.3 32.39 10.33C32.58 12.87 33.82 14.12 36.36 14.3C36.39 14.3 36.39 14.35 36.36 14.35C33.82 14.54 32.57 15.78 32.39 18.32C32.39 18.35 32.34 18.35 32.34 18.32Z"
            fill="#E9F0EB"
          />
          <path
            d="M34.6 19.64C34.36 16.78 32.94 15.36 30.08 15.12C30.03 15.12 30.03 15.05 30.08 15.05C32.94 14.81 34.36 13.39 34.6 10.53C34.6 10.48 34.67 10.48 34.67 10.53C34.91 13.39 36.33 14.81 39.19 15.05C39.24 15.05 39.24 15.12 39.19 15.12C36.33 15.36 34.91 16.78 34.67 19.64C34.67 19.69 34.61 19.69 34.6 19.64Z"
            fill="#226937"
          />
          <path d="M35.2957 15.0835L34.6381 14.4259L33.9805 15.0835L34.6381 15.7411L35.2957 15.0835Z" fill="white" />
        </g>
        <path
          d="M15.05 6.48C15.49 5.9 15.8 5.02 15.06 3.78C14.29 2.5 8.72999 1.08 8.16999 1.08C6.83999 1.08 4.09999 5.32 3.88999 6.92C2.69999 15.83 0.139994 22.46 0.699994 26.57C0.989994 28.68 1.01999 30.24 2.15999 32.92C3.10999 35.15 8.66999 35.27 12.09 35.53C16.46 35.87 21.56 39.07 29.37 36.63C39.2 33.56 37.68 29.33 36.81 26.96C32.65 15.72 19.61 12.36 14.4 22.87C13.11 25.46 12.65 25.55 12.65 25.55C11.01 17.59 8.75999 18.06 9.96999 12.81C9.96999 12.81 13.3 12.11 14.65 10.63C15.44 9.77 17.68 7.6 16.23 6.65C15.02 5.86 12.93 7.49 10.24 8.28C9.59999 8.47 11.13 6.09 10.18 5.75"
          stroke="#EC7200"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_248_5067">
          <rect width="39.46" height="39.1" fill="white" transform="translate(0 0.449997)" />
        </clipPath>
        <clipPath id="clip1_248_5067">
          <rect width="18.23" height="18.23" fill="white" transform="translate(21 1.45)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});
